import { defineMessage } from 'react-intl';

// The idea here is to put commonly used messages throughout the app in one place, with messages like
// yes, no, save, change, edit, etc.
//
// The gain of using common messages is probably low, probably better with reusable utility functions,
// hooks, components and services, we also create dependencies on global properties, which will force
// you to create your own custom messages where needed anyway.

// todo There are many unused messages here, we did not see this before as everything was a default export.
//      We should either remove the unused messages or make sure we use them, if appropriate. In fact, most
//      messages here that are used are related to form validation.

export const yesMessage = defineMessage({
    defaultMessage: 'Yes',
    description: "Generic label for 'Yes'",
});
export const noMessage = defineMessage({
    defaultMessage: 'No',
    description: "Generic label for 'No'",
});
export const saveButtonMessage = defineMessage({
    defaultMessage: 'Save',
    description: 'Save button text',
});
export const deleteButtonMessage = defineMessage({
    defaultMessage: 'Delete',
    description: 'Delete button text',
});
export const closeDialogMessage = defineMessage({
    defaultMessage: 'Close',
    description: 'Close a dialog link',
});
export const cancelMessage = defineMessage({
    defaultMessage: 'Cancel',
    description: 'Cancel an action',
});
export const goBackMessage = defineMessage({
    defaultMessage: 'Go back',
    description: 'Go back to the previous page',
});
export const doneMessage = defineMessage({
    defaultMessage: 'Done',
    description: 'When you are done editing a page that does not need saving',
});

export const confirmMessage = defineMessage({
    defaultMessage: 'Confirm',
    description: 'Label for a button when you need to confirm something',
});

export const confirmOrChangeMessage = defineMessage({
    defaultMessage: 'Confirm / Change',
    description: 'Label for a button when you need to confirm and/or edit',
});
export const changeMessage = defineMessage({
    defaultMessage: 'Change',
    description: 'Label for a button when you need to edit/change',
});

export const unexpectedServerErrorMessage = defineMessage({
    defaultMessage: 'An unexpected server error occurred.',
    description: 'Message when the server responds with an unexpected error',
});

export const invalidEmailMessage = defineMessage({
    defaultMessage: 'Please input a valid email address.',
    description:
        'Validation message for a field that requires a valid email address',
});

export const invalidPhoneNumberMessage = defineMessage({
    defaultMessage: 'Please input a valid phone number.',
    description:
        'Validation message for a field that requires a valid phone number',
});

export const inputIsRequiredMessage = defineMessage({
    defaultMessage: 'Field is required.',
    description: 'Validation message if a required field is missing',
});

export const minLengthMessage = defineMessage({
    defaultMessage: 'Minimum length is {min}.',
    description:
        'Validation message if length of an input field is shorter than {min}',
});

export const maxLengthMessage = defineMessage({
    defaultMessage: 'Maximum length is {max}.',
    description:
        'Validation message if length of an input field is longer than {max}',
});

export const fromDateMessage = defineMessage({
    defaultMessage: 'From',
});

export const toDateMessage = defineMessage({
    defaultMessage: 'To',
});

export const endDateMessage = defineMessage({
    defaultMessage: 'Date',
});
